import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export function charCount(text: string): number {
  return [...text].length
}

export function formatRelative(ts: number): string {
  const diff = Date.now() / 1000 - ts
  if (diff < 60) return 'just now'
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`
  if (diff < 86400 * 30) return `${Math.floor(diff / 86400)}d ago`
  return new Date(ts * 1000).toLocaleDateString()
}

export function formatAbsolute(ts: number): string {
  return new Date(ts * 1000).toLocaleString([], {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
}

export function toEpochSeconds(localDatetime: string): number {
  return Math.floor(new Date(localDatetime).getTime() / 1000)
}

export function toLocalDatetimeInput(ts: number): string {
  const d = new Date(ts * 1000)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}
